<template>
  <div>
    <!-- <van-nav-bar title="请选择登录账号"/> -->
    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell  v-for="(item, index) in list" :key="index" clickable @click="radioChange(index)">
          <template #title>
            <span class="custom-title">用户名：</span>
            <span class="custom-title">{{item.userName}}</span>
            <van-tag v-if="item.isAuto === '0'" type="danger">自动登录账号</van-tag>
          </template>
          <template #right-icon>
            <van-radio :name="index" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div class="btns">
      <van-button type="info" block round @click="switchAccountBtn">登录</van-button>
    </div>
  </div>
</template>

<script>
import { WechatLogins, WechatLogin } from '@/api/login'
// , IntoIndex
import { Dialog } from 'vant'
export default {
  name: 'switchAccount',
  components: {},
  props: {},
  data () {
    return {
      radio: 999,
      list: [],
      form: {},
      automaticLogin: ''
    }
  },
  watch: {},
  computed: {
  },
  methods: {
    radioChange (e) {
      this.radio = e
      this.form = this.list[e]
    },
    async switchAccountBtn () {
      if (this.radio > this.list.length - 1) return this.$toast.fail('请选择登录号')
      this.form = this.list[this.radio]
      const { data: ress } = await WechatLogin({ openId: this.$store.state.openId, userId: this.list[this.radio].userId })
      this.$store.commit('setUserID', ress[this.radio].userId + 'a')
      this.$store.commit('setToken', ress[this.radio].token)
      this.$store.commit('setUserName', ress[this.radio].userName)
      this.$store.commit('setFirstLogin', ress[this.radio].firstLogin)
      if (this.list[this.radio].isAuto === '0') {
        // const into = await IntoIndex()
        // window.open(into, '_self')
        this.$router.push({ name: 'Home' })
      } else {
        Dialog.confirm({
          title: '温馨提示',
          message: '将把该账号覆盖为当前微信自动登录账号'
        }).then(async () => {
          // on confirm
          const { data: res } = await WechatLogins({ openId: this.$store.state.openId, userId: this.list[this.radio].userId, isAuto: '0' })
          if (res.code !== 0) return this.$toast.fail('设置失败')
          this.$toast.success('自动登录设置成功')
          this.$store.commit('setIsAutoAccount', this.list[this.radio].userName)
          if (ress[this.radio].firstLogin === '0') {
            this.$router.push('/firstLoginPage')
          } else {
            // const into = await IntoIndex()
            // window.open(into, '_self')
            this.$router.push({ name: 'Home' })
          }
        }).catch(async () => {
          await WechatLogins({ openId: this.$store.state.openId, userId: this.list[this.radio].userId, isAuto: '1' })
          if (ress[this.radio].firstLogin === '0') {
            this.$router.push('/firstLoginPage')
          } else {
            // const into = await IntoIndex()
            // window.open(into, '_self')
            this.$router.push({ name: 'Home' })
          }
        })
      }
    }
  },
  beforeCreate () {},
  created () {
    this.automaticLogin = this.$store.state.signOut ? this.$store.state.signOut : 'no'
    this.list = this.$store.state.accountList
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .van-cell-group {
    .van-cell:first-child {
      padding-top: 45px;
    }
  }
  /deep/.van-tag {
    margin-left: 15px;
  }
  .btns {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    bottom: 35px;
    padding: 0 30px;
  }
</style>
